import { createVirtualPortal } from 'react-virtual-portals/src';

/**
 * Used to transport complex content from inside of an option's content area to it's controls area
 */
const OptionControlsPortal = createVirtualPortal();

export default OptionControlsPortal;
